export enum DevicePlatform {
  WEB = "WEB",
  IOS = "IOS",
  ANDROID = "ANDROID",
  EXTENSION = "EXTENSION",
}
